import { cn } from '@/utils/tailwind-util';
import React from 'react';
import * as ReactRouter from 'react-router-dom';

import Button, { CustomButtonProps } from './Button';

interface Props extends CustomButtonProps, ReactRouter.LinkProps {
  disabled?: boolean;
}

const ButtonLink = React.forwardRef<HTMLAnchorElement, Props>(
  (
    {
      to,
      replace,
      reloadDocument,
      state,
      variant,
      size,
      shadowed,
      hasPadding,
      iconElement,
      disabled = false,
      children,
      styles,
      ...rest
    },
    anchorRef
  ) => {
    const buttonRef = React.useRef<HTMLButtonElement>(null);

    return (
      <ReactRouter.Link
        to={to}
        replace={replace}
        reloadDocument={reloadDocument}
        state={state}
        ref={anchorRef}
        onFocus={() => buttonRef.current?.focus()}
        className={cn(disabled && 'pointer-events-none cursor-default')}
        {...rest}
      >
        <Button
          variant={variant}
          size={size}
          shadowed={shadowed}
          hasPadding={hasPadding}
          iconElement={iconElement}
          ref={buttonRef}
          tabIndex={-1}
          // @ts-ignore
          styles={cn(styles, !styles && 'w-full h-12')}
          disabled={disabled}
        >
          {children}
        </Button>
      </ReactRouter.Link>
    );
  }
);

ButtonLink.displayName = 'ButtonLink';

export default ButtonLink;
